import React, { useState } from 'react'

import you from '../../assets/images/boy.png'
// import bot from '../../assets/images/happy.png'
import ExecutiveEdu from './ExecutiveEdu';
import Accomodations from './Accomodations';
import ContactUs from './ContactUs';
import Other from './Other';
import Payment from './Payment';
import ApplicationAssist from './ApplicationAssist';
import Admissions from './Admissions';

const Mainmenu = () => {
//   const [time] = React.useState(new Date());
  const [time1,setTime1] = React.useState(new Date());
  
  const [showMenu, setShowMenu] = useState(true);

  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "Mainmenu" }]); // Root frame

  const handleShowFrame = (parentId, frameName) => {
    setShowMenu(false);
    setTime1(new Date());
    setActiveFrames((prevFrames) => [
      ...prevFrames,
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };
  
  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "About Executive Education":
        FrameComponent = ExecutiveEdu; // Replace with actual component
        break;
        case "Accomodations":
            FrameComponent = Accomodations; // Replace with actual component
            break;
        case "Admissions":
            FrameComponent = Admissions; // Replace with actual component
            break;
        case "Application Asistance":
            FrameComponent = ApplicationAssist; // Replace with actual component
            break;
        case "Other":
            FrameComponent = Other; // Replace with actual component
            break;
        case "Payment":
            FrameComponent = Payment; // Replace with actual component
            break;
        case "Contact Us":
            FrameComponent = ContactUs; // Replace with actual component
            break;
      
      default:
        return null;
    }
  
    return (
      <div key={frame.id}>
        <div className="you-time">
          <img src={you} alt="boy" className="boy" />
          You {time1?.toLocaleTimeString()}
        </div>
        <div className="you-message">
          <div className="frame2">{frame.component}</div>
        </div>
        <FrameComponent handleShowFrame={handleShowFrame} parentId={frame.id} />
      </div>
    );
  };
  
  return (
    <div>
      
        <div className='frame1 animated-frame'>
            What can I help you with today?<br></br>
            You may choose an option from below.
        </div>

        {
            showMenu &&
            <div className='menu-btns animated-frame'>
                <button className='menu-btn' onClick={() => handleShowFrame(2, "About Executive Education")}>About Executive Education</button>
                <button className='menu-btn' onClick={() => handleShowFrame(3, "Accomodations")}>Accomodations</button>
                <button className='menu-btn' onClick={() => handleShowFrame(4, "Admissions")}>Admissions</button>
                <button className='menu-btn' onClick={() => handleShowFrame(5, "Application Asistance")}>Application Asistance</button>
                <button className='menu-btn' onClick={() => handleShowFrame(6, "Payment")}>Payment</button>
                <button className='menu-btn' onClick={() => handleShowFrame(6, "Contact Us")}>Contact Us</button>
                <button className='menu-btn' onClick={() => handleShowFrame(6, "Other")}>Other</button>
            </div>
        }
        {activeFrames.slice(1).map(renderFrame)}
    </div>
    
  )
}

export default Mainmenu